import * as i0 from '@angular/core';
import { Component, Optional, Inject, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@pershing/pershing-core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class F2Component {
    constructor(appSettings, authService) {
        this.authService = authService;
        this.isAdaTheme = false;
        this.appSettings = appSettings;
    }
    ngOnInit() {
        if (this.entitlement !== undefined) {
            this.isEntitledforView = this.authService.isEntitled(this.entitlement);
        }
        else {
            this.isEntitledforView = true;
        }
        if (this.appSettings.themeType && this.appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
        }
    }
    ngOnDestroy() {
        if (this.f2AppRef && this.f2AppRef.nativeElement) {
            this.f2AppRef.nativeElement.remove();
        }
    }
}
F2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: F2Component, deps: [{ token: 'AppSettings', optional: true }, { token: i1.PermissionCheckerService }], target: i0.ɵɵFactoryTarget.Component });
F2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.1", type: F2Component, selector: "f2-component", inputs: { id: "id", class: "class", dataParams: "dataParams", entitlement: "entitlement" }, viewQueries: [{ propertyName: "f2AppRef", first: true, predicate: ["f2"], descendants: true }], ngImport: i0, template: "\t<div #f2 [class]=\"class\"\n\t\t[id]=\"id\" *ngIf=\"isEntitledforView\">\n\t</div>\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: F2Component, decorators: [{
            type: Component,
            args: [{ selector: 'f2-component', template: "\t<div #f2 [class]=\"class\"\n\t\t[id]=\"id\" *ngIf=\"isEntitledforView\">\n\t</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }, { type: i1.PermissionCheckerService }]; }, propDecorators: { id: [{
                type: Input
            }], class: [{
                type: Input
            }], dataParams: [{
                type: Input
            }], entitlement: [{
                type: Input
            }], f2AppRef: [{
                type: ViewChild,
                args: ['f2']
            }] } });

class PershingF2Module {
}
PershingF2Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: PershingF2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PershingF2Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.1", ngImport: i0, type: PershingF2Module, declarations: [F2Component], imports: [CommonModule], exports: [F2Component] });
PershingF2Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: PershingF2Module, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: PershingF2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [F2Component],
                    exports: [F2Component]
                }]
        }] });

/*
 * Public API Surface of pershing-f2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { F2Component, PershingF2Module };
